import React, { useRef, useState } from 'react'
import { HiOutlineMenuAlt3 } from 'react-icons/hi';
import { IoIosArrowDown } from 'react-icons/io';

import {
  Container,
  Logo,
  Wrapper,
  Button,
  DropdownButton,
  DropDownWrapper,
  TopBg,
  Link,
  LinkMenu,
  ContainerLaptop,
  SubMenu,
  SubLink
} from './styles'

export default function Navigation() {
  const dropDownRef = useRef(null)
  const [isActive, setIsActive] = useState(false)
  const onClick = () => setIsActive(!isActive)

  if(window.innerWidth < 769){
    return(
      <>
        <TopBg />
        <Container>
        <Logo />
        <DropdownButton
          onClick={onClick}
          ref={dropDownRef}
        >
        { !isActive ?
          <HiOutlineMenuAlt3
            style={{
            color: '#AD4226',
            height: '25px',
            width: '25px',
          }}/>

          : (
            <>
              <IoIosArrowDown
                style={{
                color: '#AD4226',
                height: '25px',
                width: '25px',
              }}/>

              <DropDownWrapper ref={dropDownRef}>
                  <Link href="#home"> Home </Link>
                  <Link href="#metodologia"> Metodologia </Link>
                  <Link href="#aula-ingles">Serviços</Link>
                  <SubLink>
                    <Link href="#aula-ingles">Aulas de Inglês</Link>
                    <Link href="#aula-espanhol">Aulas de Espanhol</Link>
                    <Link href="#aula-italiano">Aulas de Italiano</Link>
                    <Link href="#aula-frances">Aulas de Francês</Link>
                    <Link href="#aula-portugues">Aulas de Português</Link>
                    <Link href="#aula-individuais">Aulas Individuais</Link>
                    <Link href="#aula-grupo">Aulas em Grupo (até 4 alunos)</Link>
                    <Link href="#aula-criancas">Aulas de para Crianças</Link>
                    <Link href="#testes-proeficiencia">Preparação para Testes de Proeficiência</Link>
                  </SubLink>
                  <Link href="#quemsomos"> Quem Somos </Link>
                  <Link href="#parceiro"> Seja Nosso Parceiro </Link>
                  <Link href="#contato"> Fale Conosco </Link>
                  <Link href="#galeria"> Galeria </Link>
              </DropDownWrapper>
            </>
            )
          }
          </DropdownButton>
        </Container>
      </>
    )
  } else {
    return (
      <>
        {/* <TopBg /> */}
        <ContainerLaptop>
          <Logo />
          <Wrapper>
            <Link href="#home">Home</Link>
            <LinkMenu href="#aula-ingles">Serviços
              <SubMenu>
                <Link href="#aula-ingles">Aulas de Inglês</Link>
                <Link href="#aula-espanhol">Aulas de Espanhol</Link>
                <Link href="#aula-italiano">Aulas de Italiano</Link>
                <Link href="#aula-frances">Aulas de Francês</Link>
                <Link href="#aula-portugues">Aulas de Português</Link>
                <Link href="#aula-individuais">Aulas Individuais</Link>
                <Link href="#aula-grupo">Aulas em Grupo (até 4 alunos)</Link>
                <Link href="#aula-criancas">Aulas de para Crianças</Link>
                <Link href="#testes-proeficiencia">Preparação para Testes de Proeficiência</Link>
              </SubMenu>
            </LinkMenu>
            <Link href="#metodologia">Metodologia</Link>
            <Link href="#quemsomos">Quem Somos</Link>
            <Link href="#parceiro">Seja Nosso Parceiro</Link>
            <Link href="#contato">Fale Conosco</Link>
            <Link href="#galeria">Galeria</Link>
          </Wrapper>
          <Button>
            <a
              href='https://wa.me/5511999610535'
              target="blank"
              style={{
                textDecoration: 'none',
                color: 'white',
              }}
              >
                MATRICULE-SE
            </a>
          </Button>
        </ContainerLaptop>
      </>
    )
  }
};
